import { videoScrubSrc } from './ScrollVideo.asset';

// Модуль качает файл видео целиком один раз (под прелоадером) и отдаёт blob-ссылку.
// Так секция не догружает видео в момент прокрутки и перематывается сразу.

const state = {
  url: null,
  progress: 0,
  done: false,
};

const listeners = new Set();
let request = null;

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(state);
    } catch (e) {
      /* подписчик не должен ломать загрузку */
    }
  });
}

function finish(url) {
  state.url = url;
  state.progress = 1;
  state.done = true;
  notify();
  return url;
}

function download() {
  if (typeof fetch !== 'function') return Promise.resolve(finish(null));

  return fetch(videoScrubSrc)
    .then((response) => {
      if (!response.ok) throw new Error(`video ${response.status}`);

      const total = Number(response.headers.get('content-length')) || 0;
      const canStream = total > 0 && response.body && typeof response.body.getReader === 'function';

      // Без streams или без Content-Length честного прогресса нет — шкалу ведёт таймер
      if (!canStream) {
        state.progress = 0.99;
        notify();
        return response.blob();
      }

      const reader = response.body.getReader();
      const chunks = [];
      let received = 0;

      const pump = () =>
        reader.read().then(({ done, value }) => {
          if (done) return new Blob(chunks, { type: 'video/mp4' });
          chunks.push(value);
          received += value.length;
          state.progress = Math.min(0.99, received / total);
          notify();
          return pump();
        });

      return pump();
    })
    .then((blob) => finish(URL.createObjectURL(blob)))
    .catch(() => finish(null));
}

export function preloadScrollVideo() {
  if (!request) request = download();
  return request;
}

export function getScrollVideoState() {
  return state;
}

export function subscribeScrollVideo(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
